/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

import {
    getImagesFromAttribute,
    getImageLabel,
    getAttributeValue,
    getFakeSwatches,
    overlayerAttributeIsSet,
    mapGtmItem
} from "../../api/mapping";

const liveSearchProductsMapping = {
    /**
     * Merge products
     *
     * @param products
     * @param type
     * @returns {*}
     */
    mergeProducts(products, type) {
        const mergedProducts = type === "next"
            ? [...this.products, ...products]
            : [...products, ...this.products];
        return this.products = mergedProducts;
    },
    /**
     * Map products
     *
     * @param items
     * @param pagination
     * @returns {*[]}
     */
    mapProducts(items, pagination) {
        const loadedProducts = this.products.length;

        return items.map((item, index) => ({
            count: loadedProducts + index + 1,
            isFirstOfPage: index === 0,
            page: pagination,
            name: item.product.name,
            priceRange: item.product.price_range,
            currency: item.product.price_range.maximum_price.regular_price.currency,
            images: getImagesFromAttribute(item),
            // TODO: Is item.productView.images[0].label reliable?
            imageLabel: getImageLabel(item),
            url: item.product.canonical_url,
            id: item.product.id,
            sku: item.product.sku,
            masterNumber: getAttributeValue(item, "master_number"),
            isSale: overlayerAttributeIsSet(item, "overlayer_sale"),
            isNew: overlayerAttributeIsSet(item, "overlayer_new"),
            isSustainable: getAttributeValue(item,"sustainability"),
            isInnovative: getAttributeValue(item, "mey_innovation"),
            style: getAttributeValue(item, "style"),
            designColor: getAttributeValue(item, "design_color_select"),
            color: getAttributeValue(item, "color"),
            fakeSwatches: getFakeSwatches(item),
            gtmItem: mapGtmItem(item)
        }));
    }
}

export default liveSearchProductsMapping;
